import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

/** Catch-all for any route react-router can't match (a typo'd URL, an old
 * bookmark, a stale deep link). Before this existed, `useRoutes` returned
 * `null` for an unmatched path — a totally blank white page with nothing but
 * a "No routes matched location" warning in the console, and no way back
 * except editing the address bar by hand. */
export default function NotFoundPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const homePath = user ? (user.role === 'Hợp tác xã' ? '/htx/tong-quan' : '/nong-ho/tong-quan') : '/dang-nhap';

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center bg-slate-50">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-agrida-50 text-agrida-600">
        <i className="ri-map-pin-2-line text-3xl" />
      </span>
      <h1 className="text-2xl font-bold text-slate-900">404 — Không tìm thấy trang</h1>
      <p className="text-sm text-slate-500 max-w-sm">
        Đường dẫn này không tồn tại hoặc đã thay đổi. Kiểm tra lại địa chỉ hoặc quay về trang chủ.
      </p>
      <button
        type="button"
        onClick={() => navigate(homePath, { replace: true })}
        className="mt-2 px-5 py-3 rounded-xl bg-agrida-600 hover:bg-agrida-700 text-white text-sm font-semibold min-h-[48px]"
      >
        Về trang chủ
      </button>
    </div>
  );
}
